import { Category } from '../types';
import { mockLessons } from './mockData';

export const mockCategories: Category[] = [
  {
    id: '1',
    title: 'Mental Resilience',
    description: 'Build mental toughness and adaptability to handle workplace challenges.',
    type: 'mental_resilience',
    icon: 'brain',
    color: 'purple',
    lessons: mockLessons.filter(lesson => lesson.category === 'mental_resilience'),
  },
  {
    id: '2',
    title: 'Emotional Intelligence',
    description: 'Develop awareness and mastery of emotions for better relationships.',
    type: 'emotional_intelligence',
    icon: 'heart',
    color: 'rose',
    lessons: mockLessons.filter(lesson => lesson.category === 'emotional_intelligence'),
  },
  {
    id: '3',
    title: 'Productivity',
    description: 'Master techniques for efficient work and focused attention.',
    type: 'productivity',
    icon: 'lightbulb',
    color: 'amber',
    lessons: mockLessons.filter(lesson => lesson.category === 'productivity'),
  },
  {
    id: '4',
    title: 'Relationship & Social',
    description: 'Build meaningful connections and improve communication.',
    type: 'relationship_social',
    icon: 'users',
    color: 'blue',
    lessons: mockLessons.filter(lesson => lesson.category === 'relationship_social'),
  },
  {
    id: '5',
    title: 'Purpose & Meaning',
    description: 'Discover your mission and align work with personal values.',
    type: 'purpose_meaning',
    icon: 'compass',
    color: 'emerald',
    lessons: mockLessons.filter(lesson => lesson.category === 'purpose_meaning'),
  },
  {
    id: '6',
    title: 'Personal Growth',
    description: 'Cultivate continuous learning and self-improvement.',
    type: 'personal_growth',
    icon: 'rocket',
    color: 'indigo',
    lessons: mockLessons.filter(lesson => lesson.category === 'personal_growth'),
  },
];